(function () {
  function scrollThumbnailStrip(root, thumb) {
    var scroller = root.querySelector('[data-gallery-scroller]');
    if (!scroller || !thumb) return;

    function step() {
      var margin = 12;
      var sRect = scroller.getBoundingClientRect();
      var tRect = thumb.getBoundingClientRect();

      if (scroller.scrollWidth > scroller.clientWidth + 1) {
        if (tRect.left < sRect.left + margin) {
          scroller.scrollLeft -= sRect.left + margin - tRect.left;
        } else if (tRect.right > sRect.right - margin) {
          scroller.scrollLeft += tRect.right - (sRect.right - margin);
        }
      }

      if (scroller.scrollHeight > scroller.clientHeight + 1) {
        if (tRect.top < sRect.top + margin) {
          scroller.scrollTop -= sRect.top + margin - tRect.top;
        } else if (tRect.bottom > sRect.bottom - margin) {
          scroller.scrollTop += tRect.bottom - (sRect.bottom - margin);
        }
      }

      thumb.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: 'auto',
      });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        step();
        setTimeout(step, 0);
        setTimeout(step, 100);
      });
    });
  }

  function onMainNavClick(e) {
    var btn = e.target.closest('[data-gallery-main-prev], [data-gallery-main-next]');
    if (!btn) return;
    var root = btn.closest('[data-product-gallery]');
    if (!root) return;
    e.preventDefault();
    e.stopPropagation();
    var delta = btn.hasAttribute('data-gallery-main-prev') ? -1 : 1;
    var thumbs = root.querySelectorAll('[data-gallery-thumbnail]');
    if (!thumbs.length) return;
    var sel = root.querySelector('[data-gallery-thumbnail][data-gallery-selected="true"]');
    var idx = sel ? parseInt(sel.getAttribute('data-gallery-index'), 10) : 0;
    if (Number.isNaN(idx)) idx = 0;
    var n = thumbs.length;
    var nextIdx = (idx + delta + n * 100) % n;
    var target = root.querySelector(
      '[data-gallery-thumbnail][data-gallery-index="' + nextIdx + '"]'
    );
    if (!target) return;
    target.click();
    scrollThumbnailStrip(root, target);
  }

  document.addEventListener('click', onMainNavClick);
})();
